module.exports = __webpack_public_path__ + "landing_slider_first_slide_600х800.2e828e9.jpg";